<template>
  <a-config-provider :locale="zh_CN">
    <div id="basic-layout">
      <a-layout>
        <a-layout-header>
          <div class="sider-menu-logo" @click="showMenu = !showMenu">
            <h1>Cloud Game</h1>
          </div>

          <span class="environment">
            <span>{{ serverName }} </span></span
          >
          <a-dropdown prefixCls="">
            <span>
              <a-avatar
                :size="28"
                :style="{
                  color: getForegroundColor(userinfo.username),
                  backgroundColor: getBackgroundColor(userinfo.username),
                }"
              >
                {{ userinfo.username[0] }}
              </a-avatar>
              <span :style="{ color: getBackgroundColor(userinfo.username) }">
                {{ userinfo.username }}
              </span>
            </span>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a @click="changePwdVisible = true">修改密码</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="logout">退出登录</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </a-layout-header>
        <a-layout style="min-height: 100vh">
          <!-- v-show="showMenu" -->
          <a-layout-sider :collapsed="collapsed">
            <!-- <div class="sider-menu-logo">
            <h1 @click="showMenu = !showMenu">最强主播</h1>
          </div> -->
            <nav-menu :menus="menus" />
          </a-layout-sider>
          <a-layout-content>
            <a-tabs
              :activeKey="$route.name"
              @tabClick="tabClick"
              @edit="editTab"
              type="editable-card"
              hide-add
            >
              <a-tab-pane key="workplace" :closable="false">
                <template #tab>
                  <icon type="home" />
                </template>
              </a-tab-pane>
              <a-tab-pane
                v-for="v in routes"
                v-show="v?.name != 'workplace'"
                :key="v.name"
                :tab="v.describe"
              />
            </a-tabs>
            <div class="layout-content">
              <a-breadcrumb style="margin: 8px 0">
                <a-breadcrumb-item v-if="!!$route?.meta?.parent">
                  {{ $route?.meta?.parent }}
                </a-breadcrumb-item>
                <a-breadcrumb-item>
                  {{ $route?.meta?.describe }}
                </a-breadcrumb-item>
              </a-breadcrumb>
              <router-view />
            </div>
          </a-layout-content>
          <!-- <a-layout-footer>Footer</a-layout-footer> -->
        </a-layout>
      </a-layout>

      <a-modal
        title="修改密码"
        :width="640"
        :visible="changePwdVisible"
        @cancel="changePwdVisible = false"
        @ok="changePwd"
      >
        <a-form
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          ref="chpwdForm"
          :rules="rules"
          :model="chpwd"
        >
          <a-form-item label="旧密码" name="old_password">
            <a-input
              v-model:value="chpwd.old_password"
              type="password"
              autocomplete="off"
            />
          </a-form-item>
          <a-form-item label="新密码" name="new_password">
            <a-input
              v-model:value="chpwd.new_password"
              type="password"
              autocomplete="off"
            />
          </a-form-item>
          <a-form-item label="确认新密码" name="new_password2">
            <a-input
              v-model:value="chpwd.new_password2"
              type="password"
              autocomplete="off"
            />
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
    <div>
      <a-back-top />
      Scroll down to see the bottom-right
      <strong style="color: rgba(64, 64, 64, 0.6)"> gray </strong>
      button.
    </div>
  </a-config-provider>
</template>
<script>
import { nav, changePwd } from '@api/user'
import NavMenu from '@components/NavMenu.vue'
import { addRoutes } from '@router'
import { mapGetters, mapActions } from 'vuex'
import { getForegroundColor, extractColorByName } from '@utils/utils'
import store from 'store'
import { ACCESS_TOKEN } from '@store/mutation-types'
import { message, notification } from 'ant-design-vue'
import zh_CN from 'ant-design-vue/es/locale/zh_CN'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'

moment.locale('zh-cn')

const devTitle = '开发环境'

export default {
  components: {
    NavMenu,
  },
  watch: {
    ['$route.name'](name) {},
  },
  data() {
    let basePwdRule = [
      { required: true, message: '密码不能为空', trigger: 'blur' },
      {
        min: 8,
        max: 20,
        message: '长度8~20位',
        trigger: 'blur',
      },
      {
        message: '由字母及数字组成，且必须包含两者',
        trigger: 'blur',
        pattern: /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
      },
    ]
    return {
      zh_CN,
      serverName: document.title, // serverList[parseInt(store.get("SERVER") || 0)]?.name,
      changePwdVisible: false,
      showMenu: true,
      menus: [],
      collapsible: true,
      collapsedWidth: 0,
      collapsed: false,
      chpwd: {
        old_password: '',
        new_password: '',
        new_password2: '',
      },
      rules: {
        old_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        new_password: [
          ...basePwdRule,
          {
            validator: async (rule, value) => {
              this.$refs.chpwdForm.validate('new_password2')
              return Promise.resolve()
            },
            trigger: 'blur',
          },
        ],
        new_password2: [
          {
            validator: async (rule, value, callback) => {
              if (value !== this.chpwd.new_password) {
                return Promise.reject('两次输入的密码不一致!')
              } else {
                return Promise.resolve()
              }
            },
            trigger: 'blur',
          },
        ],
      },

      devTitle,
    }
  },
  computed: {
    ...mapGetters('user', ['userinfo']),
    ...mapGetters('route', ['routes']),
  },
  created() {
    //创建完成 data 已经有数据,dom 节点还没有初始化
    nav()
      .then((res) => {
        const childrenNav = res.data
        this.menus = childrenNav
        addRoutes(childrenNav)
        // workplace换成首页，第一个能上的页签
        if (this.$route?.path == '/dashboard/workplace') {
          let homePage = 'nomatch'
          parent: for (const key in childrenNav) {
            let value = childrenNav[key]
            if (value.parent_id) {
              homePage = value.name
              break
            }
            for (const k in value.children) {
              let v = value.children[k]
              if (v.parent_id) {
                homePage = v.name
                break parent
              }
            }
          }
          this.$router.push({ name: homePage })
        } else if (this.$route?.name == 'nomatch') {
          this.$router.push(this.$route?.path)
        }
      })
      .catch((err) => {
        notification.error({
          message: '加载菜单权限失败',
          description: err?.message,
        })
      })
  },
  methods: {
    ...mapActions('route', ['delRoute']),
    tabClick(route) {
      this.$router.push({ name: route })
    },
    editTab(routeName, action) {
      switch (action) {
        case 'remove':
          let idx = this.routes.map((r) => r.name).indexOf(routeName)
          this.delRoute(routeName)
          if (this.$route.name == routeName) {
            this.$router.push({
              name:
                (this.routes[idx] || this.routes[idx - 1])?.name || 'workplace',
            })
          }
      }
    },
    getForegroundColor(name) {
      return getForegroundColor(extractColorByName(name))
    },
    getBackgroundColor(name) {
      return extractColorByName(name)
    },
    logout() {
      store.remove(ACCESS_TOKEN)
      this.$router.push({ name: 'login' })
    },
    changePwd() {
      this.$refs.chpwdForm.validate().then((res) => {
        changePwd({
          old_password: this.chpwd.old_password,
          new_password: this.chpwd.new_password,
        })
          .then(() => {
            this.$router.push({ name: 'login' })
          })
          .catch((err) => {
            message.error(err?.message)
          })
      })
    },
  },
}
</script>
<style lang="less" scoped>
#basic-layout {
  min-width: 1200px;

  .sider-menu-logo {
    height: 64px;
    padding: 0;
    line-height: 64px;
    text-align: center;

    h1 {
      color: #fff;
      font-weight: 600;
      font-size: 20px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  .environment {
    padding-left: 20px;
    font-weight: bold;

    font-size: 20px;
    span {
      color: red;
    }
  }

  header {
    position: relative;
    padding: 0 12px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .sider-menu-logo {
      display: inline-block;
      width: 200px;
      margin-left: -12px;
      background: #001529;
    }

    .ant-dropdown-trigger {
      position: absolute;
      right: 12px;
      display: inline-block;
      height: 100%;
      padding: 0 12px;
      font-size: 18px;

      & > span:last-child {
        margin-left: 8px;
      }
    }

    .ant-dropdown-open {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .ant-layout-sider {
    .ant-menu {
      & :deep(.ant-menu-submenu-title) {
        svg {
          margin: 0 4px;
        }
      }
    }
  }

  .ant-layout-content {
    :deep(.ant-tabs) {
      background: #fff;
      .ant-tabs-nav {
        margin-left: 24px;
      }
      .ant-tabs-bar {
        margin-bottom: 1px;
      }
    }
    .layout-content {
      margin: 0 24px 0;
      :deep(.ant-card .ant-card-body) {
        & > * {
          margin-bottom: 18px;
        }

        & > .ant-form-inline {
          .ant-btn {
            margin-right: 8px;
          }
        }
      }
    }
  }

  // :deep( span.action) {
  //   & > a {
  //     margin-right: 8px;
  //   }
  // }
}
</style>
<style lang="less">
.ant-popover {
  .ant-popover-buttons {
    .ant-btn {
      color: #fff;
      background-color: #1890ff;
      border-color: #1890ff;

      &:hover,
      &:focus {
        color: #fff;
        background-color: #40a9ff;
        border-color: #40a9ff;
      }

      &:active,
      &.active {
        color: #fff;
        background-color: #096dd9;
        border-color: #096dd9;
      }
    }

    .ant-btn-primary {
      color: rgba(0, 0, 0, 0.85);
      background-color: #fff;
      border-color: #d9d9d9;

      &:hover,
      &:focus {
        color: #40a9ff;
        background-color: #fff;
        border-color: #40a9ff;
      }

      &:active,
      &.active {
        color: #096dd9;
        background-color: #fff;
        border-color: #096dd9;
      }
    }
  }
}

.ant-modal-body {
  .ant-modal-confirm-body-wrapper {
    .ant-modal-confirm-btns {
      .ant-btn {
        color: #fff;
        background-color: #1890ff;
        border-color: #1890ff;

        &:hover,
        &:focus {
          color: #fff;
          background-color: #40a9ff;
          border-color: #40a9ff;
        }

        &:active,
        &.active {
          color: #fff;
          background-color: #096dd9;
          border-color: #096dd9;
        }
      }

      .ant-btn-primary {
        color: rgba(0, 0, 0, 0.85);
        background-color: #fff;
        border-color: #d9d9d9;

        &:hover,
        &:focus {
          color: #40a9ff;
          background-color: #fff;
          border-color: #40a9ff;
        }

        &:active,
        &.active {
          color: #096dd9;
          background-color: #fff;
          border-color: #096dd9;
        }
      }
    }
  }
}
</style>
